// utils/processors/gridMediaProcessor.js

export class GridMediaProcessor {
  static processGridMedia(groupId, mediaHTML, groupText, groupAlignment, columns) {
    const alignmentClassString = groupAlignment.join(' ');
    
    let finalHTML = '';
    if (groupText) {
      finalHTML += `<div class="grid-media-text ${alignmentClassString}">${groupText}</div>`;
    }
    
    finalHTML += `
      <div class="grid-media-container ${alignmentClassString}" style="grid-template-columns: repeat(${columns}, 1fr);">
        ${mediaHTML}
      </div>
    `;
    
    return finalHTML;
  }

  static generateGridMediaHTML(groupId, mediaType, url, mediaIndex, videoId) {
    switch (mediaType) {
      case 'image':
        return `
          <div class="grid-media-item">
            <img src="${url}" alt="Image" 
                 onclick="window.openMediaPreview('${groupId}', ${mediaIndex})" 
                 class="grid-media-image" />
          </div>
        `;
      
      case 'video':
        return `
          <div class="grid-media-item">
            <div class="grid-media-video-wrapper" onclick="window.openMediaPreview('${groupId}', ${mediaIndex})">
              <video class="grid-media-video">
                <source src="${url}" type="video/mp4">
                Your browser does not support the video tag.
              </video>
              <div class="grid-media-play-button">
                <div class="grid-media-play-icon"></div>
              </div>
            </div>
          </div>
        `;
      
      case 'youtube':
        const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
        return `
          <div class="grid-media-item">
            <div class="grid-media-youtube-wrapper" onclick="window.openMediaPreview('${groupId}', ${mediaIndex})">
              <img src="${thumbnailUrl}" alt="YouTube Video" class="grid-media-youtube-thumbnail" />
              <div class="grid-media-youtube-button">
                <div class="grid-media-youtube-icon"></div>
              </div>
            </div>
          </div>
        `;
      
      default:
        return '';
    }
  }

  static getStyles() {
    return `
      /* Grid Media Styles */
      .rich-text-content .grid-media-text {
        margin-bottom: 0.5em !important;
      }

      .rich-text-content .grid-media-container {
        display: grid !important;
        gap: 1.5rem !important;
        margin: 1rem 0 !important;
        padding: 0 !important;
      }

      .rich-text-content .grid-media-item {
        aspect-ratio: 1 !important;
        width: 100% !important;
        height: 280px !important;
        border-radius: 12px !important;
        overflow: hidden !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease !important;
        margin: 0 !important;
        padding: 0 !important;
        cursor: pointer !important;
      }

      .rich-text-content .grid-media-item:hover {
        transform: translateY(-2px) !important;
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
      }

      .rich-text-content .grid-media-image {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        border-radius: 12px !important;
        margin: 0 !important;
        padding: 0 !important;
        display: block !important;
        cursor: pointer !important;
      }

      .rich-text-content .grid-media-video {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        margin: 0 !important;
        padding: 0 !important;
        display: block !important;
        pointer-events: none !important;
      }

      .rich-text-content .grid-media-video-wrapper {
        cursor: pointer !important;
        position: relative !important;
        width: 100% !important;
        height: 100% !important;
        border-radius: 12px !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .rich-text-content .grid-media-play-button {
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        background: rgba(0,0,0,0.7) !important;
        border-radius: 50% !important;
        width: 48px !important;
        height: 48px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .rich-text-content .grid-media-play-icon {
        width: 0 !important;
        height: 0 !important;
        border-left: 16px solid white !important;
        border-top: 10px solid transparent !important;
        border-bottom: 10px solid transparent !important;
        margin-left: 4px !important;
      }

      .rich-text-content .grid-media-youtube-wrapper {
        cursor: pointer !important;
        position: relative !important;
        width: 100% !important;
        height: 100% !important;
        border-radius: 12px !important;
        overflow: hidden !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .rich-text-content .grid-media-youtube-thumbnail {
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .rich-text-content .grid-media-youtube-button {
        position: absolute !important;
        top: 50% !important;
        left: 50% !important;
        transform: translate(-50%, -50%) !important;
        background: rgba(255,0,0,0.9) !important;
        border-radius: 8px !important;
        width: 68px !important;
        height: 48px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      .rich-text-content .grid-media-youtube-icon {
        width: 0 !important;
        height: 0 !important;
        border-left: 20px solid white !important;
        border-top: 12px solid transparent !important;
        border-bottom: 12px solid transparent !important;
        margin-left: 4px !important;
      }

      /* Mobile Responsiveness for Grid Media - Force Vertical Alignment */
      @media (max-width: 768px) {
        .rich-text-content .grid-media-container {
          grid-template-columns: 1fr !important;
          gap: 1rem !important;
          display: grid !important;
          max-width: 100% !important;
        }

        .rich-text-content .grid-media-item {
          height: 240px !important;
          width: 100% !important;
          max-width: 100% !important;
          aspect-ratio: 16/9 !important;
          border-radius: 8px !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
        }

        .rich-text-content .grid-media-image {
          object-fit: contain !important;
          max-height: 240px !important;
          border-radius: 8px !important;
        }

        .rich-text-content .grid-media-video {
          object-fit: contain !important;
          max-height: 240px !important;
        }

        .rich-text-content .grid-media-video-wrapper {
          border-radius: 8px !important;
        }

        .rich-text-content .grid-media-youtube-wrapper {
          border-radius: 8px !important;
        }

        .rich-text-content .grid-media-youtube-thumbnail {
          object-fit: contain !important;
          max-height: 240px !important;
        }
      }

      @media (max-width: 480px) {
        .rich-text-content .grid-media-container {
          grid-template-columns: 1fr !important;
          gap: 0.75rem !important;
          display: grid !important;
          max-width: 100% !important;
        }

        .rich-text-content .grid-media-item {
          height: 220px !important;
          border-radius: 6px !important;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1) !important;
          width: 100% !important;
          max-width: 100% !important;
          aspect-ratio: 16/9 !important;
        }

        .rich-text-content .grid-media-image,
        .rich-text-content .grid-media-video-wrapper,
        .rich-text-content .grid-media-youtube-wrapper {
          border-radius: 6px !important;
          width: 100% !important;
        }

        .rich-text-content .grid-media-image {
          object-fit: contain !important;
          max-height: 220px !important;
        }

        .rich-text-content .grid-media-video {
          object-fit: contain !important;
          max-height: 220px !important;
        }

        .rich-text-content .grid-media-youtube-thumbnail {
          object-fit: contain !important;
          max-height: 220px !important;
        }
      }

      /* Extra small screens - even more compact */
      @media (max-width: 320px) {
        .rich-text-content .grid-media-item {
          height: 200px !important;
          border-radius: 4px !important;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) !important;
        }

        .rich-text-content .grid-media-image,
        .rich-text-content .grid-media-video,
        .rich-text-content .grid-media-youtube-thumbnail {
          max-height: 200px !important;
        }

        .rich-text-content .grid-media-image,
        .rich-text-content .grid-media-video-wrapper,
        .rich-text-content .grid-media-youtube-wrapper {
          border-radius: 4px !important;
        }
      }

      /* Extra mobile safety - Override any inline grid styles */
      @media (max-width: 768px) {
        .rich-text-content .grid-media-container[style*="grid-template-columns"] {
          grid-template-columns: 1fr !important;
        }
      }
    `;
  }

  // Initialize grid media preview functions
  static initializeGridFunctions() {
    if (typeof window !== 'undefined') {
      window.openMediaPreview = function(groupId, mediaIndex) {
        // Implementation for opening media preview/lightbox
        console.log(`Opening media preview for group ${groupId}, index ${mediaIndex}`);
        // You can implement a lightbox/modal here
      };
    }
  }
}